<c-row>
  <c-col xs="12">
    <c-card class="mb-12">
      <c-card-header ngPreserveWhitespaces>
        <strong>Cierre diario y semanal</strong> <small>Concepto</small>
      </c-card-header>
      <c-card-body xs="12">
        <c-row>
          <c-col [md]="5" class="BordGuia">
            <label> <b>Semana de Liquidación</b> </label>
            <c-row class="forBor1">
              <c-col [md]="6">
                <label cLabel for="idPartner">Ejercicio</label>
                <input id="id" cFormControl [(ngModel)]="panelInfo.year" />
              </c-col>
              <c-col [md]="6">
                <label cLabel for="idPartner">Semana</label>
                <input
                  id="id"
                  cFormControl
                  (change)="selectWeek()"
                  [(ngModel)]="panelInfo.week"
                />
              </c-col>

              <c-col [md]="6" class="altDelAl">
                <label cLabel for="idPartner">Del</label>
                <input
                  id="id"
                  cFormControl
                  disabled="true"
                  value="{{ panelInfo.diaInicio | date : 'dd/MM/yyyy' }}"
                />
              </c-col>
              <c-col [md]="6" class="altDelAl">
                <label cLabel for="idPartner">Al</label>
                <input
                  id="id"
                  cFormControl
                  disabled="true"
                  value="{{ panelInfo.diaFin | date : 'dd/MM/yyyy' }}"
                />
              </c-col>
            </c-row>
          </c-col>
          <c-col [md]="7" class="BordGuia">
            <label> <b>Tipo de Cierre</b> </label>
            <form [formGroup]="guardarFG">
              <c-row class="forBor1">
                <c-col [md]="6">
                  <c-row>
                    <c-col [md]="12" class="MarTop">
                      <c-form-check [switch]="true" id="litros" name="litros">
                        <input
                          cFormCheckInput
                          type="checkbox"
                          (change)="activaCheckSemanal($event)"
                          disabled
                          checked
                        />

                        <label cFormCheckLabel>Cierre semanal</label>
                      </c-form-check>
                    </c-col>
                    <c-col [md]="12" class="MarTop">
                      <label for="">Fecha</label>
                      <input
                        id="id"
                        cFormControl
                        type="date"
                        formControlName="idDateCierre"
                      />
                    </c-col>
                  </c-row>
                </c-col>
              </c-row>
            </form>
          </c-col>
        </c-row>

        <c-col [md]="12" class="btnBuscarTp">
          <c-row>
            <c-col [md]="5"> </c-col>
            <c-col [md]="2">
              <button
                (click)="cerrarSemana()"
                [disabled]="cerrando"
                cButton
                color="primary"
                type="button"
              >
                {{cerrando ? "Cerrando":"Cerrar"}}
              </button>
            </c-col>
          </c-row>
        </c-col>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>
